import { RadioArray } from "controls/radioArray";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { registerView } from "@frui.ts/views";
import BankTransferViewModel, { PaymentInstructionType } from "viewModels/common/payment/bankTransferViewModel";
import { IconType } from "@edaz/edazkit/Icon";
import Icon from "@edaz/edazkit/Icon";
import { instructionTypeIcon } from "./instructionAssets";

const InstructionCard: FunctionComponent<{
  vm: BankTransferViewModel;
  option: { id: PaymentInstructionType; name: string; type: PaymentInstructionType };
}> = observer(({ vm, option }) => {
  const ta = (code: string) => vm.localizationService.translate(code);

  const labelContent = (
    <Card.Body className="d-flex align-items-center p-2" style={{ minHeight: "4rem" }}>
      <div
        className="d-flex flex-shrink-0 align-items-center justify-content-center mr-3"
        style={{ width: "2.5rem", height: "2.5rem" }}>
        <img style={{ width: "2rem", height: "2rem" }} src={instructionTypeIcon(option.type)} alt={ta(option.name)} />
      </div>
      <div className="flex-grow-1">
        <div
          className="m-0 font-weight-bold"
          style={{
            wordBreak: "keep-all",
            hyphens: "none",
            whiteSpace: "normal",
          }}>
          {ta(option.name)}
        </div>
      </div>
    </Card.Body>
  );

  const isSelected = vm.selectedPaymentType === option.type;

  const radioId = `payment-type-${option.type}`;
  return (
    <Card
      className={"instruction-view w-100" + (isSelected ? " border-success" : "")}
      style={{
        backgroundColor: isSelected ? "rgba(1, 177, 99, 0.1)" : "transparent",
        height: "100%",
      }}>
      <RadioArray
        custom
        label={labelContent}
        className={"instruction-type-select d-flex align-items-center label-stretch pl-0 h-100"}
        name={"paymentType"}
        target={vm}
        property="selectedPaymentType"
        isNumeric={false}
        id={radioId}
        option={option.type}
        isInvalid={false}
      />
    </Card>
  );
});

export default InstructionCard;
